import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import 'firebase/compat/firestore';
import 'firebase/compat/storage';

export const firebaseConfig = JSON.parse(process.env.REACT_APP_FIREBASE_CONFIG as string);

const extendedFirebaseConfig = {
	...firebaseConfig,
	authDomain:
		firebaseConfig.projectId === 'platform-prod-3621172'
			? 'app.conveyo.io'
			: firebaseConfig.projectId === 'platform-uat-362117'
			? 'uat.conveyo.io'
			: firebaseConfig.projectId === 'platform-360120'
			? 'dev.conveyo.io'
			: 'platform-360120.firebaseapp',
};

const firebaseURL = process.env.REACT_APP_FIREBASE_FUNCTIONS_URL;

// eslint-disable-next-line
let firebaseApp: ReturnType<typeof firebase.initializeApp>;
try {
	firebaseApp = firebase.initializeApp(extendedFirebaseConfig);
	// eslint-disable-next-line
} catch (err: any) {
	if (!/already exists/.test(err.message)) {
		console.error('Firebase initialization error', err.stack);
	}
}

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
const db = firebaseApp.firestore();
const auth = firebase.auth();

db.settings({ ignoreUndefinedProperties: true, experimentalForceLongPolling: true });

export { auth, db, firebaseURL, firebaseApp };
